import styled, { css } from 'styled-components';

export const Limiter = styled.div`
  margin: -5px 0 30px;
  padding: 8px 10px;
  position: relative;
  min-height: 60px;
  ${(props) =>
    props.$loading &&
    css`
      &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        z-index: 999;
        width: 100%;
        height: 100%;
        background: rgba(57, 62, 68, 0.8) url('/images/loader2.svg') no-repeat 50% 50%;
        background-size: 20px auto;
      }
    `}
`;

export const LimiterItem = styled.div`
  margin: 7px 0 0;
  display: flex;
  align-items: center;
  label {
    cursor: pointer;
    margin: 0 0 0 10px;
    &.left-side {
      margin: 0 10px 0 0;
    }
  }
  input {
    font-size: 16px;
    padding: 3px 5px;
  }
  [type='checkbox'] {
    cursor: pointer;
    width: 17px;
    height: 17px;
  }
`;

export const ToggleWrapper = styled.div`
  label {
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .toggle-input {
    opacity: 0;
    width: 0;
    height: 0;
    margin: 0;

    &:checked + span {
      background-color: #4caf50;
    }
    &:checked + span:before {
      transform: translateX(18px);
    }
  }

  .toggle-slider {
    position: relative;
    width: 40px;
    height: 22px;
    cursor: pointer;
    display: inline-block;
    background: #ccc;
    border-radius: 22px;
    margin-right: 12px;
    vertical-align: middle;
    transition: background 0.3s;

    &::before {
      position: absolute;
      content: '';
      height: 18px;
      width: 18px;
      left: 2px;
      top: 2px;
      background: #fff;
      border-radius: 50%;
      transition: 0.3s;
    }
  }
`;
